var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8515_10212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.61213 15.7735C9.26922 16.1251 8.85137 16.3905 8.39144 16.5487C7.9315 16.7069 7.44202 16.7536 6.96148 16.6852C6.48095 16.6168 6.02244 16.4351 5.62203 16.1544C5.22162 15.8737 4.89021 15.5017 4.65386 15.0676H6.14724L6.58396 13.8616H4.27612C4.24981 13.6213 4.24981 13.3787 4.27612 13.1384H6.96609L7.4028 11.9336H4.65448C4.89069 11.4994 5.22201 11.1272 5.6224 10.8464C6.02279 10.5656 6.48131 10.3838 6.96189 10.3153C7.44248 10.2469 7.93202 10.2936 8.392 10.4518C8.85199 10.61 9.26986 10.8754 9.61276 11.2271L10.5 10.3181C9.97933 9.78483 9.33623 9.39413 8.62976 9.18189C7.92328 8.96965 7.17608 8.94268 6.45678 9.10345C5.73748 9.26421 5.06914 9.60757 4.51312 10.102C3.95711 10.5964 3.53126 11.226 3.27468 11.933H1.75494L1.31822 13.1384H3.0149C2.99618 13.3793 2.99618 13.6213 3.0149 13.8623H0.93672L0.5 15.067H3.27468C3.53123 15.7739 3.95703 16.4035 4.51296 16.8979C5.06889 17.3923 5.73714 17.7356 6.45635 17.8965C7.17556 18.0573 7.92269 18.0304 8.62912 17.8183C9.33555 17.6062 9.97865 17.2157 10.4994 16.6825L9.61213 15.7735Z",
    fill: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8515_10212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.6667H10.3C10.3 12.6267 11.533 13.4444 13 13.4444C14.467 13.4444 15.7 12.6267 15.7 11.6667C15.7 10.6889 14.764 10.3333 12.784 9.86222C10.876 9.39111 8.5 8.80444 8.5 6.33333C8.5 4.74222 9.823 3.39111 11.65 2.93778V1H14.35V2.93778C16.177 3.39111 17.5 4.74222 17.5 6.33333H15.7C15.7 5.37333 14.467 4.55556 13 4.55556C11.533 4.55556 10.3 5.37333 10.3 6.33333C10.3 7.31111 11.236 7.66667 13.216 8.13778C15.124 8.60889 17.5 9.19555 17.5 11.6667C17.5 13.2578 16.177 14.6089 14.35 15.0622V17H11.65V15.0622C9.823 14.6089 8.5 13.2578 8.5 11.6667Z",
    fill: "currentColor"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_8515_10212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.74675 7.10823L3.08764 7.97553C3.6146 7.79059 4.47308 7.52941 4.73098 7.52941C5.10489 7.52941 5.38332 7.62729 5.70547 7.74023C6.05128 7.86212 6.44348 8 6.96196 8C7.48713 8 8.33535 7.56659 8.5 7.48L8.10065 6.63812C7.77895 6.80753 7.19443 7.05882 6.96196 7.05882C6.58805 7.05882 6.30962 6.96094 5.98747 6.848C5.64167 6.72612 5.24946 6.58823 4.73098 6.58823C4.6288 6.58823 4.49628 6.60565 4.34859 6.63482C4.59801 6.09412 4.73098 5.44047 4.73098 4.70588H6.06957V3.76471H4.5641C4.54536 3.71435 4.52662 3.66306 4.50833 3.61553C4.39321 3.31859 4.28478 3.03765 4.28478 2.35294C4.28478 1.70871 4.51725 0.941176 5.62337 0.941176C6.61571 0.941176 6.97133 1.98918 6.98516 2.03106L7.83115 1.73318C7.80884 1.66259 7.26493 0 5.62337 0C3.97825 0 3.39239 1.21553 3.39239 2.35294C3.39239 3.05459 3.4968 3.45882 3.60567 3.76471H2.5V4.70588H3.83859C3.83859 5.86682 3.44058 6.74259 2.74675 7.10823Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8515_10212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 9,
    fill: "white",
    transform: "translate(0.5 9)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8515_10212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 16,
    fill: "white",
    transform: "translate(8.5 1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_8515_10212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 8,
    fill: "white",
    transform: "translate(2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/currency.c3a92874.svg";
export { ForwardRef as ReactComponent };